var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calendar-pagination-arrow__container",on:{"click":function (event) { return _vm.$emit('click', event); }}},[(_vm.direction === 'left')?_c('arrow-left'):_vm._e(),(_vm.direction === 'right')?_c('arrow-right'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }